import classNames from 'classnames';
import { DateTime } from 'luxon';
import { forwardRef } from 'react';
import View from '../../../View';
import Txt from '../../../Txt';
import Input from '../../../Input';
import styles from './CustomInput.module.scss';

/**
 * CustomInput
 *
 * @return {JSX.Element}
 */
const CustomInput = (props, ref) => {
  const {
    value,
    onClick,
    className,
    label,
    disabled,
    reverse,
    name,
    required,
    asInput,
  } = props;

  console.log(props);

  const newVal = DateTime.fromJSDate(new Date(value)).toLocaleString(
    DateTime.DATE_FULL
  );

  // console.log(props);
  return (
    <View
      className={classNames(
        styles.CustomInput,
        className,
        CustomInput.displayName
      )}
      onClick={onClick}
      ref={ref}
    >
      {asInput ? (
        <Input
          name={name}
          value={newVal}
          reverse={reverse}
          required={required}
          readOnly
          fullWidth
        />
      ) : (
        <>
          <Txt className={styles.TxtValue} x>
            {newVal}
          </Txt>
          {!disabled && label ? <Txt regular>{label}</Txt> : null}
        </>
      )}
    </View>
  );
};

CustomInput.displayName = 'CustomInput';

export default forwardRef(CustomInput);
